import type { CSSProperties } from 'react';
import { useEffect } from 'react';

import { useWalletContext } from '#src/contexts/wallet/index.ts';
import { useHasChanged } from '#src/hooks/state/useHasChanged.ts';

interface Props {
  className?: string;
  withoutHeader?: boolean;
  style?: CSSProperties;
}

export const Placeholder = ({ className, style, withoutHeader }: Props) => {
  const { walletNode, setWalletNode } = useWalletContext();
  const [hasStyleChanged] = useHasChanged(style);
  useEffect(() => {
    if (hasStyleChanged && walletNode) {
      walletNode.dispatchEvent(new Event('styleChanged', { bubbles: false }));
    }
  }, [hasStyleChanged, walletNode]);

  const effectiveStyle = !withoutHeader
    ? style
    : { ...style, '--header-size': 0 };

  return (
    <div ref={setWalletNode} className={className} style={effectiveStyle} />
  );
};
